import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiObjectData } from 'src/app/core/models/api-object-data';
import SignaturePad from 'signature_pad';

//-------- Models --------//
import { User } from 'src/app/core/models/user';
import { Country } from 'src/app/core/models/country';
import { Language } from 'src/app/core/models/language';

//-------- Services --------//
import { UserService } from 'src/app/core/service/user.service';
import { AlertService } from 'src/app/core/service/alert.service';
import { BaseService } from 'src/app/core/service/base.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-outside-profile',
  templateUrl: './outside-profile.component.html',
  styleUrls: ['./outside-profile.component.scss']
})
export class OutsideProfileComponent implements OnInit, AfterViewInit {

  @ViewChild('userForm', { static: false }) userForm: NgForm;

  user = {} as User;
  countries: Country[];
  lang: string = 'ar';
  languages: Language[];
  disabled: true;
  selectedSign = "assets/images/sign_example.png";
  uploadSignature: boolean = false;
  isEdit: boolean = false;
  isShowUpload:boolean = true;
  isShowWrite:boolean = true;

  @ViewChild('signatureCanvas',{static:true}) signaturePadElement: any;
  signaturePad: any;
  signatureImg: any;
  canvasWidth: number;
  canvasHeight: number;

  constructor(
    private userService: UserService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public baseService: BaseService,
    private router: Router,
    private elementRef: ElementRef,
  ) { }


  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.signaturePadElement.width = this.signaturePadElement.offsetWidth * ratio;
    this.signaturePadElement.height = this.signaturePadElement.offsetHeight * ratio;
    this.signaturePadElement.getContext("2d").scale(ratio, ratio);
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.route.data.subscribe(
      data => {
        this.baseService.blockStop();
        this.user = data.user.returnData;
        if (this.user.photoBase64 != "") {
          const image = document.getElementById("sign_img")
          image.setAttribute("src", "data:image/png;base64," + this.user.photoBase64)
          this.uploadSignature = true
        }
        this.countries = data.countries.returnData;
        this.languages = data.languages.returnData;
      },
      error => {
        this.alertService.error(error);
      }
    );
  }

  saveData() {
    this.baseService.blockStart();
    this.userService.save(this.user).subscribe(
      (apiObjectData: ApiObjectData) => {
        this.baseService.blockStop();
        this.user = apiObjectData.returnData as User;
        if (apiObjectData.message.type === 'Success') {
          this.alertService.success(this.translate.instant("toastrMsg.savedSuccessfully"));
          this.router.navigate(['/authentication/signin'])
        }
      },
      error => {
        this.baseService.blockStop();
        if (error.status === 500) {
          this.alertService.error(this.translate.instant("toastrMsg.dataFilled"));
        }
        if (error.error.status === 400) {
          this.alertService.error(this.translate.instant("toastrMsg.dataFilled"));

        }
      }
    );
  }

  userSignImage_onChange(event: { target: { files: any[]; }; }) {
    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader();
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result: any = reader.result;
        const image = document.getElementById("sign_img")
        this.user.photoBase64 = (result as string).split(',')[1];
        image.setAttribute("src", "data:image/png;base64," + this.user.photoBase64)
        this.userForm.form.markAsDirty();
      };
    }
  }

  removeSignature() {
    var sign = document.getElementById("sign_img")
    var signatureInput = document.getElementById("txtUserSignature")
    sign.setAttribute('src', 'assets/images/signature.png');
    this.user.photoBase64 = "";
    this.uploadSignature = false;
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  cancelSavingSignatrue() {
    const signData = this.signaturePad.toData();
    if(signData) {
      signData.pop();
      this.signaturePad.fromData(signData);
    }
  }

  saveSignature(dataURL:any, name:any) {
    if(navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1){
      window.open(dataURL);
    }else{
      const blob = this.URLtoBlob(dataURL);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      this.signatureImg = blob;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  URLtoBlob(dataURL:any){
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawL = raw.length;
    const array = new Uint8Array(rawL);
    for(let i=0; i<rawL; i++){
      array[i] = raw.charCodeAt(i);
    }

    return new Blob([array],{type: contentType});
  }

  savePNG() {
    if(this.signaturePad.isEmpty()) {
      alert('There is no signature | عفواً لا يوجد توقيع')
    }else {
      const u = this.signaturePad.toDataURL();
      this.saveSignature(u,'signatureImg.png');
      this.signatureImg = u;
    }
  }

  saveJPG() {
    if(this.signaturePad.isEmpty()) {
      alert('There is no signature | عفواً لا يوجد توقيع')
    }else {
      const u = this.signaturePad.toDataURL();
      this.saveSignature(u,'signatureImg.jpg');
      this.signatureImg = u;
    }
  }

  saveSVG() {
    if(this.signaturePad.isEmpty()) {
      alert('There is no signature | عفواً لا يوجد توقيع')
    }else {
      const u = this.signaturePad.toDataURL('image/svg+xml');
      this.saveSignature(u,'signatureImg.svg');
      this.signatureImg = u;
    }
  }

  saveJustSignature() {
    const photoBase64 = this.signaturePad.toDataURL();
    this.signatureImg = photoBase64;
    this.user.photoBase64 = this.signaturePad.toDataURL().split(',')[1];
    this.userForm.form.markAsDirty();
  }

  showUploadSection() {
    this.isShowUpload = !this.isShowUpload;
    this.isShowWrite = true;
  }

  showWriteDection() {
    this.isShowWrite = !this.isShowWrite;
    this.isShowUpload = true;
  }

}
